import * as React from 'react';
import {connect} from 'react-redux';
import {setSuccess} from '../../actions/loadingActions';
import {IHistory} from '../../interfaces';
import {getUserData} from '../../services/utilityServices';
import {getCurrentUserUUID} from '../../utils/generalUtils';
import {Async} from '../reusableComponents/Async';
import {BasePage} from '../reusableComponents/BasePage';
import {ErrorPage} from '../reusableComponents/ErrorPage';
import {Loader} from '../reusableComponents/Loader/Loader';
import './homepage.scss';
import {HomePageCard} from './HomePageCard';

export interface IHomeProps {
    history: IHistory;
    id: string;
    accessLevel: string;
}

export class HomeImpl extends React.Component<IHomeProps, {}> {
    constructor(props: IHomeProps) {
        super(props);
    }

    public renderSuperAdminHomePage = () => {
        const {id} = this.props;
        return [<div key="1" className="row-one employee">
             <HomePageCard
                location="/training/list"
                className="left-top"
                icon="chalkboard-teacher"
                label="Training Modules"
                history={this.props.history}
            />
            <HomePageCard
                location="/org/list"
                className="left-top"
                icon="building"
                label="Organizations."
                history={this.props.history}
            />
            {/* <HomePageCard
                location={`/users/list`}
                className="right-top"
                icon="user-circle"
                label="Users"
                history={this.props.history}
            /> */}
        </div>,
        <div key="2" className="row-one">
        {/* <HomePageCard location="/users/list"
                      className="left-bottom" icon="users" label="User Profiles" history={this.props.history}/> */}
         <HomePageCard
                location={`/users/list`}
                className="left-bottom"
                icon="user-circle"
                label="Users"
                history={this.props.history}
            />
        <HomePageCard
            location={`/libraryrequest/${id}`}
            className="right-bottom"
            icon="chalkboard"
            label="Library Requests"
            history={this.props.history}
        />
    </div>];
    }

    public renderAdminHomePage = () => {
        const {id} = this.props;
        return [<div key="1" className="row-one">
            <HomePageCard
                location="/training/list"
                className="left-top"
                icon="chalkboard-teacher"
                label="Training Modules"
                history={this.props.history}
            />
            <HomePageCard location="/user-module/list"
                          className="right-top" icon="user" label="Assigned Modules" history={this.props.history}/>
        </div>,
            <div key="2" className="row-one">
                <HomePageCard location="/users/list"
                              className="left-bottom" icon="users" label="User Profiles" history={this.props.history}/>
                <HomePageCard
                    location={`/certificates/${id}`}
                    className="right-bottom"
                    icon="certificate"
                    label="Completed Certificates"
                    history={this.props.history}
                />
            </div>];
    }

    public renderEmployeeHomepage = () => {
        const {id} = this.props;
        return <div className="row-one employee">
            <HomePageCard
                location="/training/list"
                className="left-top"
                icon="chalkboard-teacher"
                label="Training Modules"
                history={this.props.history}
            />
            <HomePageCard
                location={`/certificates/${id}`}
                className="right-top"
                icon="certificate"
                label="My Certificates"
                history={this.props.history}
            />
        </div>;
    }

    public renderContent = () => {
        const {accessLevel} = this.props;
        const isSuperAdmin = accessLevel === 'L1';
        const isAdmin = accessLevel === 'L2';
        return isSuperAdmin ? this.renderSuperAdminHomePage() : isAdmin ? this.renderAdminHomePage() : this.renderEmployeeHomepage();
    }

    public render() {
        const {accessLevel} = this.props;
        const isAdmin = accessLevel === 'L1';
        return <BasePage className={isAdmin ? 'homepage' : 'homepage employees'} icon="home" title="Home">
            <Async
                identifier="HomePage"
                content={this.renderContent()}
                loader={<Loader type="async"/>}
                promise={() => setSuccess('HomePage')}
                error={<ErrorPage/>}

            />
        </BasePage>;
    }
}
 
export function mapStateToProps(state) {
    return {
        accessLevel: getUserData().accessLevel,
        id: getCurrentUserUUID()
    };
}

export const Home = connect<{}, {}, IHomeProps>(mapStateToProps)(HomeImpl);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Home/index.tsx